import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";
import { NotificationsProvider as CustomNotificationsProvider } from "../providers/notifications/NotificationsProvider";

const Layout: React.FC = () => {
  const auth = useContext(AuthContext);
  if (auth) {
    return <Navigate to="/" replace />;
  }
  return (
    <CustomNotificationsProvider>
      <Outlet />
    </CustomNotificationsProvider>
  );
};

export default Layout;
